const initialState = {
  errorMessage: "",
  successMessage: "",
};

export const toast = {
  namespaced: true,
  state: initialState,
  getters: {
    getErrorMessage: (state) => state.errorMessage,
    getSuccessMessage: (state) => state.successMessage,
  },
  actions: {
    error: ({ commit }, message) => {
      commit("SET_ERROR_MESSAGE", message);
    },
    success: ({ commit }, message) => {
      commit("SET_SUCCESS_MESSAGE", message);
    },
    reset: ({ commit }) => {
      commit("RESET_TOAST");
    },
  },
  mutations: {
    SET_ERROR_MESSAGE(state, payload) {
      state.errorMessage = payload;
    },
    SET_SUCCESS_MESSAGE(state, payload) {
      state.successMessage = payload;
    },
    RESET_TOAST(state) {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
};
